import { useIsPageOwner } from './useIsPageOwner';
import { usePageOwnerIdentityStore } from '../store/pageOwnerIdentityStore';
import { useCareerState } from './useApi/useCareer';
import { canShowCareerList } from '../util/visibility/aboutVisibility';
import type { ResourceScope } from '../util/scopedResource';

/** Career 목록 canShow (Indexing 모달 등) */
export const useCanShowCareerList = (): boolean => {
  const isOwner = useIsPageOwner();
  const pageOwnerAui = usePageOwnerIdentityStore((s) => s.pageOwner?.aui);
  const { listOwnerAui, listScope, status } = useCareerState();
  const currentScope: ResourceScope = isOwner ? 'owner' : 'public';

  return canShowCareerList({
    pageOwnerAui,
    listOwnerAui,
    listScope,
    currentScope,
    status,
  });
};
